export default __webpack_public_path__ + "static/media/RTR1604V_Posterior.e1f33c18.webp";